import m from "../../es2015/themes/frozen";
window.am4themes_frozen = m;


//////////////////
// WEBPACK FOOTER
// ./themes/frozen.js
// module id = null
// module chunks = 